module.exports = __webpack_public_path__ + "static/img/news@2x.9123999e.png";